export enum QuickNoteLevels {
    Info,
    Warn,
    Success,
    Error,
    None
  }